export default __webpack_public_path__ + "static/media/564.81030b67.png";